import type { LiabilityFormLayout } from "../types"

export const liabilityQuantityPercentLayout = (): LiabilityFormLayout => {
  return {
    render: 'quantityPercent'
  }
}
